import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.contentmap.title',
    defaultMessage: 'EDIT SIMULATION • CONTENT MAP',
  },
  back: {
    id: 'simulated.contentmap.back',
    defaultMessage: 'Back',
  },
  addedAbilitys: {
    id: 'simulated.contentmap.addedAbilitys',
    defaultMessage: 'ADDED SKILLS',
  },
  filters: {
    id: 'simulated.contentmap.filters',
    defaultMessage: 'Filters',
  },
  clear: {
    id: 'simulated.contentmap.clear',
    defaultMessage: 'Clear',
  },
  applyFilters: {
    id: 'simulated.contentmap.applyFilters',
    defaultMessage: 'Apply filters',
  },
  abilities: {
    id: 'simulated.contentmap.abilities',
    defaultMessage: 'Abilitys',
  },
  approveAll: {
    id: 'simulated.contentmap.approveAll',
    defaultMessage: 'Approve all',
  },
  seeMore: {
    id: 'simulated.contentmap.seeMore',
    defaultMessage: 'SEE MORE',
  },
  application: {
    id: 'simulated.contentmap.application',
    defaultMessage: 'Application',
  },
  yearClass: {
    id: 'simulated.contentmap.class',
    defaultMessage: 'Year/Class',
  },
  curricularComponent: {
    id: 'simulated.contentmap.curricularComponent',
    defaultMessage: 'Curricular Component',
  },
  unit: {
    id: 'simulated.contentmap.unit',
    defaultMessage: 'Unit',
  },
  theme: {
    id: 'simulated.contentmap.theme',
    defaultMessage: 'Theme',
  },
  field: {
    id: 'simulated.contentmap.field',
    defaultMessage: 'Field',
  },
  analysing: {
    id: 'simulated.contentmap.analysing',
    defaultMessage: 'Analysing',
  },
  done: {
    id: 'simulated.contentmap.done',
    defaultMessage: 'Done',
  },
  approvedWaiting: {
    id: 'simulated.contentmap.approvedWaiting',
    defaultMessage: 'Done, waiting to send',
  },
  approve: {
    id: 'simulated.contentmap.approve',
    defaultMessage: 'Approve',
  },
  reprove: {
    id: 'simulated.contentmap.reprove',
    defaultMessage: 'Reprove',
  },
  status: {
    id: 'simulated.contentmap.status',
    defaultMessage: 'Status',
  },
  edit: {
    id: 'simulated.contentmap.edit',
    defaultMessage: 'Edit',
  },
  delete: {
    id: 'simulated.contentmap.delete',
    defaultMessage: 'Delete',
  },
  abilitiesRelatedToContent: {
    id: 'simulated.contentmap.abilitiesRelatedToContent',
    defaultMessage: 'Abilities related',
  },
  otherAbilities: {
    id: 'simulated.contentmap.otherAbilities',
    defaultMessage: 'Other abilities',
  },
  status_0: {
    id: 'simulated.contentmap.status_0',
    defaultMessage: 'New',
  },
  status_1: {
    id: 'simulated.contentmap.status_1',
    defaultMessage: 'In analisis',
  },
  status_2: {
    id: 'simulated.contentmap.status_2',
    defaultMessage: 'To approve',
  },
  status_3: {
    id: 'simulated.contentmap.status_3',
    defaultMessage: 'Approved, waiting to send',
  },
  status_4: {
    id: 'simulated.contentmap.status_4',
    defaultMessage: 'Concluded',
  },
  status_fallback: {
    id: 'simulated.contentmap.status_fallback',
    defaultMessage: 'Status not registered',
  },
  reproved: {
    id: 'simulated.contentmap.reproved',
    defaultMessage: 'Reproved',
  },
  catalogingSubtitle: {
    id: 'simulated.contentmap.catalogingSubtitle',
    defaultMessage:
      '{name} - {quantity} questions - {quantityAbilities} abilities - {questionsPerAbility} questions per ability',
  },
  generateSheet: {
    id: 'simulated.contentmap.generateSheet',
    defaultMessage: 'Generate sheet',
  },
  schoolContent: {
    id: 'simulated.contentmap.schoolContent',
    defaultMessage: 'School Content',
  },
  officialAbility: {
    id: 'simulated.contentmap.officialAbility',
    defaultMessage: 'Official Ability Code',
  },
  indicator: {
    id: 'simulated.contentmap.indicator',
    defaultMessage: 'Indicator',
  },
  id: {
    id: 'simulated.contentmap.id',
    defaultMessage: 'ID',
  },
  curricularComponent: {
    id: 'simulated.contentmap.curricularComponent',
    defaultMessage: 'Curricular component',
  },
  sheetFilename: {
    id: 'simulated.contentmap.sheetFilename',
    defaultMessage: 'sheet_abilities_evaluation{idEvaluation}',
  },
  objectOfKnowledge: {
    id: 'simulated.contentmap.objectOfKnowledge',
    defaultMessage: 'Object of knowledge',
  },
});
